import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GasMeterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"gas_meter"}/>
}
